export const cachePolicyMs = {
  referenceGeography: 1000 * 60 * 60,
  mapBootstrap: 1000 * 60 * 5,
  villageDetail: 1000 * 60 * 5,
  intervieweeListing: 1000 * 60 * 10,
  intervieweeDetail: 1000 * 60 * 5,
} as const;
